// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"7b9b0cef","75":"d86a5e03","379":"93b6320f","488":"14c00384","501":"2ce35aa0","551":"38e67c4e","641":"b070e0af","650":"adc6262e","654":"8a1acfcd","683":"6ed70fa4","737":"b96c218c","742":"1bd370ed","816":"7b380410"}[chunkId] + ".chunk.js";
};